import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModalModule } from 'ngx-bootstrap/modal';

import { AngularAlertComponent } from './angular-alert.component'

@NgModule({
    imports: [ ModalModule.forRoot(), CommonModule],
    declarations: [AngularAlertComponent],
    exports: [AngularAlertComponent],
    providers: []
})
export class AngularAlertModule { }


// WEBPACK FOOTER //
// ./src/angular_library/components/alert/angular-alert.module.ts